import angularJwt from "angular-jwt";
import { IHttpProvider, jwt } from "angular";
import { isLocalhost } from "@gtmhub/env";
import { getToken, AuthenticationResolverService } from "./authentication-resolver-service";
import { AuthorizationService } from "./authorization-service";

const mod = angular.module("auth", [angularJwt]);
mod.service("AuthenticationResolverService", AuthenticationResolverService);
mod.service("AuthorizationService", AuthorizationService);

mod.config([
  "$httpProvider",
  "jwtInterceptorProvider",
  "jwtOptionsProvider",
  "appConfig",
  function ($httpProvider: IHttpProvider, jwtInterceptorProvider: jwt.IJwtInterceptor, jwtOptionsProvider: jwt.IJwtOptionsProvider) {
    jwtInterceptorProvider.tokenGetter = getToken;

    const whiteListedDomains: (string | RegExp)[] = [/^.+\.gtmhub\.com$/i];
    if (isLocalhost(window.location.hostname)) {
      whiteListedDomains.push(window.location.hostname);
    }

    jwtOptionsProvider.config({ whiteListedDomains });

    $httpProvider.interceptors.push("jwtInterceptor");
  },
]);

export default mod.name;
